import { apiClient } from '@devd-client/api';
import { getToken, getOrgId } from '@devd-client/devd/auth';
import { GetWorkflowsResponse } from '../helpers/goals.types';

export const getWorkflows = (team: string): Promise<GetWorkflowsResponse> =>
  apiClient(`/v1/workflows/${getOrgId()}${team ? `?team=${team}` : ''}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const postAutomation = (params: any): Promise<any> => {
  return apiClient(`/v1/workflows/${getOrgId()}/${params.team}/enable`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      templateId: params.key.templateId,
      enabled: params.enabled,
    }),
  });
};
